(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.site-header__hamburger').forEach((btn) => {
      btn.addEventListener('click', () => {
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        const next = !expanded;
        btn.setAttribute('aria-expanded', String(next));
        btn.setAttribute('aria-label', next ? btn.dataset.labelClose : btn.dataset.labelOpen);
        const drawerId = btn.getAttribute('aria-controls');
        const drawer = drawerId ? document.getElementById(drawerId) : null;
        if (drawer) {
          drawer.classList.toggle('is-open', next);
          drawer.setAttribute('aria-hidden', String(!next));
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
